<template>
  <div>
    <h1 class="blind">Oceankeeper admin</h1>
    <AppHeader />
    <div class="container">
      <Navigation v-if="isLoggedIn" class="natigator"/>
      <div class="content-area">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import AppHeader from "@/views/HeaderView.vue";
import Navigation from "@/views/NavigationView.vue";

export default {
  components: {
    AppHeader,
    Navigation,
},
  setup(){
    const store = useStore()
    const isLoggedIn = computed(()=>store.getters['login/isAuthenticated'])
    return {isLoggedIn}
  }
};

</script>

<style>
.blind {
  display:none;
}

.container {
  width: 100%;
  min-height: calc(100vh - 78px);
  display: flex;
  background-color: #37474F;
  margin-top: 78px;
}

.content-area {
  margin-left: 400px;
  width: calc(100% - 400px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 40px;
}

body{
  margin: 0;
  padding: 0;
  font-family: "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
}

/* 작은 화면 대응 */
@media (max-width: 1440px) {
  .content-area {
    margin-left: 300px;
    width: calc(100% - 300px);
  }
}

@media (max-width: 1024px) {
  .content-area {
    margin-left: 250px;
    width: calc(100% - 250px);
  }
}
</style>